




































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { bus } from "@/bus";
// components
import vSelect from "vue-select";
import StageDeleteModal from "@/components/stages/modals/StageDeleteModal.vue";
import StageInfoModal from "@/components/stages/modals/StageInfoModal.vue";
// service methods
import { getStages, getFilters } from "@/services/stages/stageService";
// types
import { Filter, Stage } from "@/services/stages/types";
import { stagesFields } from "@/components/stages/fields/stagesFields";
import { Option } from "@/services/common/types";
// css
import "vue-select/dist/vue-select.css";

@Component({
    components: {
        vSelect,
        "stage-delete-modal": StageDeleteModal,
        StageInfoModal
    }
})
export default class Stages extends Vue {
    // local state
    stages = [] as Array<Stage>;
    fields = stagesFields;
    isBusy = false;
    sortBy = "name";
    sortDesc = false;

    // filter options
    searchText = "" as string;
    solutions = [] as Array<Option>;
    designs = [] as Array<Option>;
    selectedSolution = null as Option | null;
    selectedDesign = null as Option | null;

    // lifecycle hooks
    public created(): void {
        this.fetchData();

        bus.$on("reload", () => {
            this.fetchData();
        });
    }

    beforeDestroy() {
        bus.$off("reload");
    }

    // methods & actions
    deleteStage(stageId: string, name: string) {
        (this.$refs.stageDeleteModal as any).open(stageId, name);
    }

    stageInfo(stageId: string) {
        (this.$refs.stageInfoModal as any).open(stageId);
    }

    addStage() {
        this.$router.push({
            name: "createStage"
        });
    }

    updateStage(stageId: string) {
        this.$router.push({
            name: "updateStage",
            params: { stageId: stageId }
        });
    }

    fetchData() {
        this.loadStages();
        this.getFilters();
    }

    loadStages() {
        this.isBusy = true;
        this.stages = [] as Array<Stage>;
        const filter = { solutionId: this.selectedSolution ? this.selectedSolution.id : null, designId: this.selectedDesign ? this.selectedDesign.id : null } as Filter;
        getStages(filter).then(response => {
            this.stages = response;
            this.isBusy = false;
        });
    }

    clearFilter() {
        this.selectedSolution = null;
        this.selectedDesign = null;
        this.loadStages();
    }

    getFilters() {
        getFilters().then(response => {
            this.solutions = response.solutions.map(x => ({ id: x.id, text: x.name }));
            this.designs = response.designs.map(x => ({ id: x.id, text: x.name }));
        });
    }

    // computed and watchers
    get model(): Array<Stage> {
        return this.stages.filter(
            x => (this.searchText === "" ? true : x.name.toLowerCase().includes(this.searchText.toLowerCase()))
        );
    }
}
